export default __webpack_public_path__ + "static/media/mexc.15bd8d63.svg";